import { Button, Offcanvas, Table } from "react-bootstrap";
import { FaTrashAlt } from "react-icons/fa";
import { sharedServices } from "../../APIServices/PasswordManagement/sharedServices";
import { useEffect } from "react";
import { useState } from "react";
import Swal from "sweetalert2";
import Moment from "react-moment";
import { MdOutlineCategory } from "react-icons/md";

const ShareList = ({ Show, Hide, groupData, groupId, isDark, auth }) => {
  const [sharedList, setSharedList] = useState([]);
  const [loader, setLoader] = useState(false);
  const getSharedGroupList = async () => {
    setLoader(true)
    let data = await sharedServices.getSharedGroupList(auth, groupId)
    setSharedList(data?.data || [])
    setLoader(false)
  }

  const revokedSharedGroup = async (groupId, sharedId, sharedWith, id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to revoked this shared group?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, revoked it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const userData = {
          groupId: groupId,
          sharedId: sharedId,
          sharedWith: sharedWith,
          id: id,
        };
        const data = await sharedServices.revokedSharedGroup(auth, userData);
        if (data?.statusCode === 200) {
          getSharedGroupList();
        }
      }
    });
  };

  const deleteSharedGroup = async (groupId, sharedId, sharedWith, id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete share history?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33"
    }).then(async (result) => {
      if (result.isConfirmed) {
        const userData = {
          groupId: groupId,
          sharedId: sharedId,
          sharedWith: sharedWith,
          id: id,
        };
        const data = await sharedServices.deleteSharedGroup(auth, userData);
        if (data?.statusCode === 200) {
          getSharedGroupList();
        }
      }
    });
  };

  function isExpired(expiryAt) {
    if (!expiryAt) {
      return false;
    }
    const now = new Date();
    return now > new Date(expiryAt);
  }

  useEffect(() => {
    if (groupId && Show) {
      getSharedGroupList()
    }
  }, [auth, groupId, Show]);
  return (
    <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: 600 }}>
      <Offcanvas.Header
        closeButton
        className={`${isDark ? "bg-dark" : "bg-light"} py-3 ps-2 border-bottom`}
      >
        <Offcanvas.Title
          className="fw-bold hstack gap-2"
          style={{ fontSize: 15 }}
        >
          <MdOutlineCategory />
          <span>{groupData?.groupName} Share History</span>
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body className="p-0">
        <Table hover className="m-0" style={{ verticalAlign: "middle" }}>
          <thead className="position-sticky top-0">
            <tr>
              <th className="CP" style={{ fontSize: 13 }}>Shared With</th>
              <th className="CP" style={{ fontSize: 13 }}>Expiries</th>
              <th className="CP text-center" style={{ fontSize: 13 }}>Status</th>
              <th className="CP text-center" style={{ fontSize: 13 }}>Revoke</th>
              <th className="CP text-center" style={{ fontSize: 13 }}>Delete</th>
            </tr>
          </thead>
          <tbody>
            {sharedList?.map((item, index) => (
              <tr key={index}>
                <td className="item-secondary">
                  <div className="item-title mb-1">{item?.sharedWithName}</div>
                  <div className="d-block mb-1">{item?.sharedWithEmail}</div>
                  <Moment title="Shared Date | Time" format="DD MMM YYYY | HH:mm">
                    {item?.sharedAt}
                  </Moment>
                </td>
                <td className="item-secondary">
                  <Moment format="DD MMM YYYY | HH:mm" withTitle>
                    {item?.expiryAt}
                  </Moment>
                </td>
                <td
                  className={`CP item-secondary text-center text-capitalize fw-bold ${(item?.isRevoked || isExpired(item?.expiryAt)) ? "text-danger" : "text-success"}`}>
                  {item?.isRevoked ? "Revoked" : isExpired(item?.expiryAt) ? "Expired" : "Shared"}
                </td>
                <td
                  onClick={() => {
                    if (!(item?.isRevoked || isExpired(item?.expiryAt))) {
                      revokedSharedGroup(item?.groupId, item?.sharedId, item?.sharedWith, item?.id)
                    }
                  }
                  }
                  className="item-secondary text-center"
                  title={item?.isRevoked && `Revoked By: ${item?.revokedByName}\nRevoked DT: ${item?.revokedAt}`}
                >
                  <Button
                    variant={(item?.isRevoked || isExpired(item?.expiryAt)) ? "outline-secondary" : "outline-primary"}
                    disabled={(item?.isRevoked || isExpired(item?.expiryAt))}
                    className={!(item?.isRevoked || isExpired(item?.expiryAt)) && "fw-bold"}
                    style={{ fontSize: 11, padding: "1px 4px", borderRadius: 3 }}
                  >
                    {item?.isRevoked ? "Revoked" : "Revoke Now"}
                  </Button>
                </td>
                <td
                  onClick={() => {
                    if (item?.isRevoked || isExpired(item?.expiryAt)) {
                      deleteSharedGroup(item?.groupId, item?.sharedId, item?.sharedWith, item?.id)
                    }
                  }
                  }
                  className="item-secondary text-center CP"
                  title="Delete Share History"
                >
                  <FaTrashAlt className={(item?.isRevoked || isExpired(item?.expiryAt)) ? "text-danger" : "text-secondary"} />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ShareList;
